import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';
import { ComicCard } from './ComicCard';

export function LatestUpdatesSection() {
  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3">
              每日更新
            </span>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              最新
              <span className="text-accent-500">更新</span>
            </h2>
          </div>
          <Link
            to="/category/action"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {latestUpdates.slice(0, 9).map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="compact" />
          ))}
        </div>
      </div>
    </section>
  );
}